import { render } from "./SubUsers.vue?vue&type=template&id=5c692c38"
import script from "./SubUsers.vue?vue&type=script&lang=js"
export * from "./SubUsers.vue?vue&type=script&lang=js"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__